import { evalConditionalPageProp } from "src/hooks/useActivePageProps";

import { isCalorieClinicalRoute } from "@utils/userSegment";
import {
  GlobalHeaderConfig,
  GlobalHeaderConfigOverrides,
} from "@pageDefinitions/types/GlobalHeaderConfig";
import { useLocation } from "react-router";
import { useStore } from "react-redux";
import { getActivePage } from "@pageDefinitions/pageSets";
import { CoreReduxState } from "@utils/redux/store";
import { PageSetHistoryState } from "@pageDefinitions/components/PageSetRouter";
import { isInsideWebView } from "@pageDefinitions/goto/utils";

declare module "@pageDefinitions/types" {
  export interface PageSetPageConfigProps {
    useGlobalHeader?: ConditionalPageProp<GlobalHeaderConfig>;
    useGlobalHeaderOverrides?: GlobalHeaderConfigOverrides;
  }
}

export function getDefaultGlobalHeaderConfig(): GlobalHeaderConfig {
  if (isCalorieClinicalRoute()) {
    // Hide exit button on desktop OR mobile web (but show in mobile webview)
    const shouldHideExitButton = !isInsideWebView();

    return {
      enabled: true,
      sticky: true,
      theme: "PROJECT_CALORIE",
      exitAction: {
        exitBuyflow: [],
      },
      hideExitButton: shouldHideExitButton,
    };
  }
  return {
    enabled: false,
  };
}

export function useGlobalHeaderConfig(): GlobalHeaderConfig {
  const location = useLocation<PageSetHistoryState>();
  const store = useStore<CoreReduxState>();
  const { activePage } = getActivePage(
    location.pathname,
    store.getState(),
    location
  );

  if (!activePage) {
    return getDefaultGlobalHeaderConfig();
  }
  const { useGlobalHeader, useGlobalHeaderOverrides } = activePage?.props || {};

  const config = {
    ...getDefaultGlobalHeaderConfig(),
    ...evalConditionalPageProp(useGlobalHeader),
  };
  return {
    ...config,
    ...(config.enabled && useGlobalHeaderOverrides),
  };
}
